import {
	get,
	post
} from './http'

export default {
	getWeChatPaySetParams(openid, type, flightOrderNum, ticketOrderNum = '', appointOrderNum = '') {
		return post('Payment/getWeChatPaySetParams', {
			OpenId: openid,
			Type: type,
			FlightOrderNum: flightOrderNum,
			TicketOrderNum: ticketOrderNum,
			AppointOrderNum: appointOrderNum
		});
	},
	getWeChatPayParams(openid, id, businessid, ordertype) {
		return get('Payment/getWeChatPayParamsV2', {
			openid: openid,
			id: id,
			type: businessid,
			ordertype: ordertype
		});
	},
	getIcbcWeChatPayParams(openid, id, type) {
		return get('Payment/getIcbcWeChatPayParams', {
			openid: openid,
			id: id,
			type: type
		});
	},
	getIcbcPayQRcode(openid, id, ordertype) {
		return get('Payment/getIcbcUserOrderPayQCode', {
			openid: openid,
			id: id,
			type: ordertype
		});
	},
	userRefundTicketOrder(openid, id) {
		return post('Payment/userApplyRefund', {
			openid: openid,
			id: id
		});
	},
	userRefundScopeOrder(openid, id) {
		return post('Payment/userApplyScopeRefund', {
			openid: openid,
			id: id
		});
	},
	userRefundAppointOrder(openid, id) {
		return post('Payment/userApplyAppointRefund', {
			openid: openid,
			id: id
		});
	},
	checkPayState(openid, id, ordertype) {
		return get('Payment/checkPayState', {
			openid: openid,
			id: id,
			type: ordertype
		});
	}
}



// WEBPACK FOOTER //
// ./src/request/paymentApi.js